// resources/front/default/js/alpine/navBar.js

/**
 * Alpine component — Navigation bar front
 * Gère : menu mobile, dark mode, persistance thème
 *
 * Enregistré via Alpine.data('navBar', navBar)
 * Utilisé dans : resources/views/front/partials/navbar.blade.php
 *   → <header x-data="navBar()">
 */
const navBar = () => ({

    mobileOpen: false,
    dark: false,

    // ── Init ─────────────────────────────────────────────────────
    init() {
        // Restaurer le thème sauvegardé
        const saved = localStorage.getItem('theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

        console.log('💡 Theme preference:', { saved, prefersDark });

        this.dark = saved ? saved === 'dark' : prefersDark;
        this._applyTheme();

        // Fermer mobile menu sur resize
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 768) this.mobileOpen = false;
        }, { passive: true });

        // Fermer mobile menu sur navigation HTMX
        document.body.addEventListener('htmx:afterSettle', () => {
            this.mobileOpen = false;
        });
    },

    // ── Dark mode ─────────────────────────────────────────────────
    toggleDark() {
        this.dark = !this.dark;
        this._applyTheme();
        localStorage.setItem('theme', this.dark ? 'dark' : 'light');
    },

    _applyTheme() {
        document.documentElement.classList.toggle('dark', this.dark);
    },

    // ── Mobile ────────────────────────────────────────────────────
    toggleMobile() {
        this.mobileOpen = !this.mobileOpen;
    },

    closeMobile() {
        this.mobileOpen = false;
    },
    openSearch() {
        window.dispatchEvent(new CustomEvent('open-site-search'));
        // Si menu mobile ouvert, le fermer
        this.mobileOpen = false;
    }
});

export default navBar;